import React, { Fragment, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { Show, useAccess } from 'react-redux-permission';
import { Link } from 'react-router-dom';
import {
    getPickAndPack,
    sortTableByColumn,
    handleSearchInputMUI,
    getSelectedRows,
    confirmDeleteDialogBox,
} from '../../redux/actions/pick_and_pack/pick_and_pack.actions';
import PickAndPackTable from './PickAndPack.table';

function PickAndPack({
    pick_and_pack: {
        batch_list,
        pagination,
        search,
        loading,
        edit_url,
        // edit_page,
        pick_url,
        pack_url,
        sort_order_name,
        sort_order_direction,
        set_row_checked,
    },
    getPickAndPack,
    handleSearchInputMUI,
}) {
    const { hasPermission } = useAccess();

    return (
        <div className="app-content content">
            <ReactTooltip effect="solid" event="click" />
            <div className="content-wrapper max-1920 mx-auto">
                <div className="content-wrapper-before"></div>
                <div className="content-header row">
                    <div className="content-header-left col-md-12 col-12 mb-2 breadcrumb-new fix-header">
                        <h3 className="content-header-title mb-0 d-inline-block">
                            Fulfillment
                        </h3>
                        <div className="breadcrumbs-top d-inline-block">
                            <div className="breadcrumb-wrapper mr-1">
                                <ol className="breadcrumb f-regular">
                                    <li className="breadcrumb-item">
                                        <Link
                                            to="/purchases/purchase-orders/"
                                            className="text-white"
                                        >
                                            Pick & Pack
                                        </Link>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-body margin-top-5">
                    <section id="basic-examples">
                        <div className="row">
                            <div className="col-sm-12">
                                <div id="what-is" className="">
                                    <div className="card-content collapse show">
                                        <div className="card-body no-padding-top no-padding-left-right">
                                            <section className="row">
                                                <div className="col-sm-12">
                                                    <ul className="nav nav-tabs f-regular"></ul>
                                                    <div className="tab-content px-1 pt-1 card-box-top card">
                                                        <div
                                                            role="tabpanel"
                                                            className="tab-pane active table-responsive "
                                                            id="tabs"
                                                            aria-expanded="true"
                                                            aria-labelledby="base-tab1"
                                                        >
                                                            <Show when="inv.fulfillment.pick-and-pack.view">
                                                                <div className="content-body margin-top-5">
                                                                    <section id="basic-examples">
                                                                        <div className="row">
                                                                            <div className="col-12">
                                                                                <div className="card">
                                                                                    <div className="card-header">
                                                                                        <h4 className="card-title">
                                                                                            Batch
                                                                                            List
                                                                                            <a
                                                                                                href="#"
                                                                                                className="tool-tip"
                                                                                                data-tip="this is a tool tip"
                                                                                            >
                                                                                                <i className="la la-question-circle"></i>
                                                                                            </a>
                                                                                            <Show when="inv.fulfillment.pick-and-pack.pick">
                                                                                                <button
                                                                                                    onClick={() => {
                                                                                                        const popupWindow =
                                                                                                            window.open(
                                                                                                                pick_url,
                                                                                                                'Pick Window',
                                                                                                                'width=320,height=534'
                                                                                                            );
                                                                                                        popupWindow.focus();
                                                                                                    }}
                                                                                                    className="btn btn-primary btn-sm pull-right btn-fix-header m-1"
                                                                                                >
                                                                                                    <i className="ft ft-plus"></i>{' '}
                                                                                                    Pick
                                                                                                </button>
                                                                                            </Show>
                                                                                            <Show when="inv.fulfillment.pick-and-pack.pack">
                                                                                                <button
                                                                                                    onClick={() => {
                                                                                                        const popupWindow =
                                                                                                            window.open(
                                                                                                                pack_url,
                                                                                                                'Pack Window',
                                                                                                                'width=320,height=534'
                                                                                                            );
                                                                                                        popupWindow.focus();
                                                                                                    }}
                                                                                                    className="btn btn-primary btn-sm pull-right btn-fix-header m-1"
                                                                                                >
                                                                                                    <i className="ft ft-plus"></i>{' '}
                                                                                                    Pack
                                                                                                </button>
                                                                                            </Show>
                                                                                        </h4>
                                                                                    </div>
                                                                                    <div className="card-content collapse show">
                                                                                        <div className="card-body">
                                                                                            <section className="row">
                                                                                                <div className="col-sm-12">
                                                                                                    <PickAndPackTable />
                                                                                                </div>
                                                                                            </section>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </section>
                                                                </div>
                                                            </Show>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    pick_and_pack: state.pick_and_pack,
});

export default connect(mapStateToProps, {
    getPickAndPack,
    handleSearchInputMUI,
})(PickAndPack);
